const cptName = 'mieszkania';
const hotspotsData = document.querySelector('#data-for-hotspots');
const flatsArr = [];

if (hotspotsData) {
    Array.from(hotspotsData.children).forEach((hotspotData) => {
        flatsArr.push({
            title: hotspotData.children[0].textContent,
            status: hotspotData.children[1].textContent,
            link: hotspotData.children[2].textContent,
        });
    });
}

const waitForElm = (selector) => {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
};

waitForElm('.hotspots-map').then(() => {
    const hotspotsInfo = document.querySelectorAll('.hotspot-info');

    if (hotspotsInfo.length > 0) {
        hotspotsInfo.forEach((hotspot) => {
            const title = hotspot.children[0];
            const description = hotspot.children[1];

            if (title && title.textContent.includes(cptName)) {
                const flatObj = flatsArr.find((flat) => flat.link === title.textContent);

                if (flatObj) {
                    title.textContent = flatObj.status;
                    description.textContent = flatObj.title;

                    title.classList.add(flatObj.status);
                    description.style.fontWeight = 'bold';
                }
            }
        });
    }
});

waitForElm('.hotspots-map-container').then(() => {
    const hotspotsPath = document.querySelectorAll('.hotspot-default.leaflet-interactive');

    if (hotspotsPath) {
        hotspotsPath.forEach((path) => {
            const name = path.getAttribute('name');
            const ariaLabel = path.getAttribute('aria-label');

            if (name.includes(cptName) && ariaLabel.includes(cptName)) {
                const flatObj = flatsArr.find((flat) => flat.link === name);

                if (flatObj) {
                    path.addEventListener('click', () => {
                        window.open(flatObj.link, '_self');
                    });

                    path.classList.add(flatObj.status);
                }
            }
        });
    }
});
